import styled, { css } from 'styled-components';
import { THEME } from '@/common/styles/theme';
import { OPINION_DECISION } from '@/pages/customer/chat/constants/opinion.constants';

export const BaseSVG = styled.svg.attrs({
	viewBox: '0 0 24 24',
	fill: 'none',
	xmlns: 'http://www.w3.org/2000/svg',
})`
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	display: block;
	transition: all 0.2s ease;
`;

export const Wrapper = styled.div`
	display: flex;
	padding: 4px 0;
	opacity: 0.7;
	transition: opacity 0.2s;

	&:hover {
		opacity: 1;
	}
`;

export const IconButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background: none;
	border: none;
	cursor: pointer;
	padding: 6px;
	transition: all 0.2s ease;
	color: ${THEME.muted};

	svg {
		stroke: currentColor;
		fill: none;
		@media (min-width: 768px) {
			width: 24px;
			height: 24px;
		}
	}

	${(props) =>
		props.$isActive &&
		props.$decision === OPINION_DECISION.HAND_UP &&
		css`
			color: ${THEME.green};
			filter: drop-shadow(0 0 3px ${THEME.green}80);
			transform: scale(1.1);
		`}

	${(props) =>
		props.$isActive &&
		props.$decision === OPINION_DECISION.HAND_DOWN &&
		css`
			color: ${THEME.error};
			filter: drop-shadow(0 0 3px ${THEME.error}80);
			transform: scale(1.1);
		`}

	:hover:not([disabled]):not([$isActive]) {
		color: ${THEME.pink};
		transform: scale(1.05);
	}
`;
